module.exports = __webpack_public_path__ + "img/logo-patchshealth.7999a96d.svg";